import React, { Component } from 'react'

export default class AccountForm extends Component{
    constructor (props){
        super(props)
        this.state = {
            branch_name: '',
            branch_address: '',
            branch_tel: '',
            account: this.props.account
        }
        this.onChangeHandle = this.onChangeHandle.bind(this)
        this.onUserChangeHandle = this.onUserChangeHandle.bind(this)
    }

  /* componentDidMount() {
    console.log('===componentDidMount')
    console.log(this.state.account)
  }*/

   componentWillReceiveProps(nextProps) {
    let accountNew = nextProps.account
    let accountOld = this.props.account

    if(JSON.stringify(accountNew) !== JSON.stringify(accountOld)) {
      this.setState({account: accountNew})
    }
  }

  onChangeHandle (event) {
     event.preventDefault()
    //alert (event.target.name);
    let xname = event.target.name
    if (xname === 'fullname') {
      this.setState({
        account: {
          ...this.state.account ,
          fullname: event.target.value }
      })
    } else if (xname === 'email') {
      this.setState({
        account: {
          ...this.state.account ,
          email: event.target.value
        }
      })
    } else if (xname === 'mobile') {
      this.setState({
        account: {
          ...this.state.account ,
          mobile: event.target.value
        }
      })
    } else if (xname === 'address') {
      this.setState({
        account: {
          ...this.state.account ,
          address: event.target.value
        }
      })
    } else if(xname === 'type') {
      this.setState({
        account: {
          ...this.state.account ,
          type: event.target.value
        }
      })
    }
    //
  }

  onUserChangeHandle(event) {
    event.preventDefault()
    if(this.props.actionType==="บันทึก") {
      this.setState({
        account: {
          ...this.state.account,
          user: event.target.value
        }
      })
    }
  }

    render(){
        return (
            <div className="card card-accent-danger">
                <div className="card-header">
                    <strong>เพิ่มข้อมูลผู้ใช้/ข้อมูลพนักงาน</strong>
                </div>
                <form action="" method="post"
                      onSubmit={ (this.props.actionType==="แก้ไข")? this.props.onSubmit.update :this.props.onSubmit.add  }>

                    <div className="card-block">
                        <div className="form-group">
                            <label htmlFor="user">username</label>
                            <input name="user"
                                   id="user"
                                   value={this.state.account.user || ''}
                                   type="text"
                                   className="form-control"
                                   placeholder="username ภาษาอังกฤษเท่านั้น"
                                   onChange={this.onUserChangeHandle}
                                   />
                        </div>

                        <div className="form-group">
                            <label htmlFor="pass">password</label>
                            <input name="pass"
                                   type="password"
                                   className="form-control"
                                   id="pass"
                                   />
                        </div>

                        <div className="form-group">
                            <label htmlFor="fullname">ชื่อ-นามสกุล </label>
                            <input
                                   name="fullname"
                                   type="text"
                                   className="form-control"
                                   placeholder="ชื่อ-นามสกุล"
                                   value={this.state.account.fullname || ''}
                                   onChange={this.onChangeHandle}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="email">อีเมล์</label>
                            <input name="email"
                                   value={this.state.account.email || ''}
                                   type="text"
                                   className="form-control"
                                   id="email"
                                   placeholder="กรอกเบอร์อีเมล์"
                                   onChange={this.onChangeHandle}/>
                        </div>

                        <div className="form-group">
                            <label htmlFor="mobile">เบอร์มือถือ</label>
                            <input name="mobile"
                                   ref="mobile"
                                   value={this.state.account.mobile || ''}
                                   type="text" className="form-control"
                                   id="mobile"
                                   placeholder="กรอกเบอร์มือถือ"
                                   onChange={this.onChangeHandle}/>
                        </div>
                        <div className="form-group">
                            <label htmlFor="address">ที่อยู่</label>
                            <input name="address"
                                   ref="address"
                                   value={this.state.account.address || ''}
                                   type="text" className="form-control"
                                   id="address"
                                   placeholder="กรอกที่อยู่"
                                   onChange={this.onChangeHandle}/>
                        </div>
                        <div className="form-group">
                            <label htmlFor="type">สิทธิ์การใช้งาน</label>
                            {/*<input name="type"
                                   ref="type"
                                   value={this.props.actionType==="แก้ไข"? this.props.account.type:"officer"}
                                   type="text" className="form-control"
                                   id="type"
                                   placeholder="สิทธิ์การใช้งาน"
                             />*/}
                              <select
                                className="form-control"
                                id="type"
                                name="type"
                                ref="type"
                                value={this.state.account.type || ''}
                                onChange={this.onChangeHandle}
                              >
                                <option  value="sale">พนักงานขาย</option>
                                <option  value="subsale">ผู้ช่วยพนักงานขาย</option>
                                <option  value="freelance">freelance</option>
                                <option  value="technician">ช่างเทคนิค</option>
                                <option  value="manager">back office</option>
                                <option  value="admin">ผู้ดูแลระบบ</option>
                              </select>
                        </div>
                    </div>

                        <div className="card-footer text-right">
                            <button type="reset" className="btn btn-sm btn-danger"><i className="fa fa-refresh"></i> ยกเลิก</button>
                            <button type="submit" className="btn btn-sm btn-primary">
                                <i className={this.props.actionType==="แก้ไข"? "fa fa-edit":"fa fa-save"}></i> {this.props.actionType}</button>
                        </div>

                </form>
            </div>
        );
    }
}
//export  default BranchForm;
